<template>
    <div>
        <sys-pop-over-config-base :model="model" :configs="noConfigs">
            <template v-slot:notice>
                <sys-notice-config-moved />
            </template>
        </sys-pop-over-config-base>
    </div>
</template>

<script>

export default {
    name: "SysWorkTimePopOver",
    data: () => ({
        noConfigs: [],
    }),
    props: {
        model: {
            type: Object,
        },
        errors: {}
    },
}
</script>
